import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

export const getTeams = async () => {
  return (await wrapCall({ method: callGet, uri: '/teams' })) as APITeam[]
}

export const postTeam = async (data: TeamUpdate) => {
  return (await wrapCall({ method: callPost, uri: '/teams', data })) as APITeam
}

export const putTeam = async (id: string, data: TeamUpdate) => {
  return (await wrapCall({
    method: callPut,
    uri: `/teams/${id}`,
    data
  })) as APITeam
}

export const deleteTeam = async (id: string) => {
  return await wrapCall({ method: callDelete, uri: `/teams/${id}` })
}
